"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ifl_components_1 = require("@indeed/ifl-components");
const AskemSurveyPopupWrapper = ({ children }) => (react_1.default.createElement(ifl_components_1.Box, { sx: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        top: 0,
        left: 0,
        zIndex: 100,
        pointerEvents: 'none',
    } }, children));
exports.default = AskemSurveyPopupWrapper;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNrZW1TdXJ2ZXlQb3B1cFdyYXBwZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9Bc2tlbVN1cnZleVBvcHVwV3JhcHBlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBMEI7QUFDMUIsMkRBQTZDO0FBRTdDLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxFQUFFLFFBQVEsRUFBNkIsRUFBZSxFQUFFLENBQUMsQ0FDdEYsOEJBQUMsb0JBQUcsSUFDQSxFQUFFLEVBQUU7UUFDQSxLQUFLLEVBQUUsTUFBTTtRQUNiLE1BQU0sRUFBRSxNQUFNO1FBQ2QsUUFBUSxFQUFFLE9BQU87UUFDakIsT0FBTyxFQUFFLE1BQU07UUFDZixjQUFjLEVBQUUsVUFBVTtRQUMxQixVQUFVLEVBQUUsVUFBVTtRQUN0QixHQUFHLEVBQUUsQ0FBQztRQUNOLElBQUksRUFBRSxDQUFDO1FBQ1AsTUFBTSxFQUFFLEdBQUc7UUFDWCxhQUFhLEVBQUUsTUFBTTtLQUN4QixJQUVBLFFBQVEsQ0FDUCxDQUNULENBQUM7QUFFRixrQkFBZSx1QkFBdUIsQ0FBQyJ9